module.exports = __webpack_public_path__ + "static/typography-guide-b17ef24313de55d8750372356011a8c4.png";